import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const GetEmailVerificationCode = async () => {
  try {
    const codeDoc = await doc(
      db,
      "EmailVerificationCode",
      getAuth().currentUser.uid
    );
    const codeDocSnapshot = await getDoc(codeDoc);
    const userDocDetails = codeDocSnapshot.data();

    console.log("userDocDetails.code", userDocDetails.code);
    return userDocDetails.code;
  } catch (error) {
    console.log(error);
  }
};

export default GetEmailVerificationCode;
